import * as React from 'react';
import _ from 'lodash';
import { Grid } from 'semantic-grab-ui/src';
import './WidgetComponent.scss';
import { Campaign } from 'types/ts/campaigns';

const ExperimentTreatmentShow = ({
  model,
  currentNode,
  parentNode,
}: {
  model: Campaign;
  currentNode: string;
  parentNode: string;
}) => {
  const groupID = _.get(model.nodes[currentNode], 'data.groupID', 0);
  const children = _.get(model.nodes[parentNode], 'children', []);
  const treatmentPercentages = _.get(
    model.nodes[parentNode],
    'data.groupPercentage',
    [],
  );

  const childIndex = children.indexOf(currentNode.toString());
  const isControlGroup = groupID === 0;
  const percentage =
    isControlGroup
      ? 100 - _.sum(treatmentPercentages)
      : treatmentPercentages[childIndex - 1];
  return (
    <div>
      <Grid>
        <Grid.Column width={8}>
          {isControlGroup ? 'Control Group' : 'Treatment Group'} Percentage
        </Grid.Column>
        <Grid.Column width={4}>{percentage}%</Grid.Column>
      </Grid>
    </div>
  );
};

export default ExperimentTreatmentShow;
